import { PermissionEnum, PermissionDesctiptionEnum } from 'api/permissions/permissions.enum';
import {
  GroupTerminalsPermissionsQueryKeysEnum,
  QueryKeyLocalStorageEnum,
  GroupTerminalsPermissionsReaderNameSortEnum,
  GroupTerminalsPermissionsIdSortEnum,
} from 'context/query/queryContext/QueryContext.enum';
import { useLocale } from 'hooks/useLocale/useLocale';
import { AppMessages } from 'i18n/messages';
import { Table } from 'ui/table/Table';

export const GroupTerminalsTableHeader = () => {
  const { formatMessage } = useLocale();

  const premissionsFilterItems = Object.values(PermissionEnum).map((permission) => ({
    name: formatMessage({ id: PermissionDesctiptionEnum[permission] }),
    filterBy: permission,
  }));

  return (
    <>
      <Table.HeaderSortItem
        queryKey={QueryKeyLocalStorageEnum.GROUP_TERMINALS_PERMISSIONS}
        sortBy={GroupTerminalsPermissionsIdSortEnum}
        queryHeader={formatMessage({ id: AppMessages['group.reader.permissions.table.header.id'] })}
      />

      <Table.HeaderSortItem
        queryKey={QueryKeyLocalStorageEnum.GROUP_TERMINALS_PERMISSIONS}
        sortBy={GroupTerminalsPermissionsReaderNameSortEnum}
        queryHeader={formatMessage({ id: AppMessages['group.reader.permissions.table.header.readerName'] })}
      />

      <Table.HeaderFilterItem
        queryKey={QueryKeyLocalStorageEnum.GROUP_TERMINALS_PERMISSIONS}
        queryName={GroupTerminalsPermissionsQueryKeysEnum.REJESTRUJ_ODBICIE}
        filterItems={premissionsFilterItems}
        queryHeader={formatMessage({ id: AppMessages['group.reader.permissions.table.header.registerRecord'] })}
        queryHeaderDescriptions={PermissionDesctiptionEnum}
      />

      <Table.HeaderFilterItem
        queryKey={QueryKeyLocalStorageEnum.GROUP_TERMINALS_PERMISSIONS}
        queryName={GroupTerminalsPermissionsQueryKeysEnum.OTWIERAJ_ZAMEK}
        filterItems={premissionsFilterItems}
        queryHeader={formatMessage({ id: AppMessages['group.reader.permissions.table.header.openLock'] })}
        queryHeaderDescriptions={PermissionDesctiptionEnum}
      />

      <Table.HeaderFilterItem
        queryKey={QueryKeyLocalStorageEnum.GROUP_TERMINALS_PERMISSIONS}
        queryName={GroupTerminalsPermissionsQueryKeysEnum.REJESTRUJ_RCP}
        filterItems={premissionsFilterItems}
        queryHeader={formatMessage({ id: AppMessages['group.reader.permissions.table.header.registerRcp'] })}
        queryHeaderDescriptions={PermissionDesctiptionEnum}
      />
    </>
  );
};
